import { UntypedFormArray } from '@angular/forms';

import { SnFormFieldConfig } from '../types/form-field-config.type';
import { SnFormOptions } from '../types/form-options.type';

export interface ISnFormStep {
  label: string;
  description?: string;
  fields: SnFormFieldConfig[];
  hideExpression?(): boolean;
}

export interface ISnHasStepperForm<Model = Object> {
  readonly form: UntypedFormArray;
  readonly formSteps: ISnFormStep[];
  readonly formOptions?: SnFormOptions[];
  formModel: Model;

  submitForm(model: Model): void;
  resetForm?(): void;
}
